import React from 'react';
import { useAdminUsersQuery } from 'api';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Empty, Form, Row, Select, Spin, Typography } from 'components';
import { FilterDrawer } from '../filterDrawer';
import { CalendarIcon, FilterIcon } from '../icons';
import { LogsIcon } from '../icons/LogsIcon';
import { LogGroup } from './LogGroup';
import styles from './styles.module.scss';
import { useLogs } from './useLogs';

const { RangePicker } = DatePicker;

interface ILogs {
  entityName: string;
  id?: string;
  isAdminLogs?: boolean;
  service?: string;
}

export const Logs = ({ id, isAdminLogs, service, entityName }: ILogs) => {
  const { data: adminsList = [] } = useAdminUsersQuery();
  const {
    logs,
    showDrawer,
    filterDrawerVisible,
    form,
    closeDrawer,
    applyFilters,
    clearFilters,
    logListLoading,
    lastLogRef,
    firstLogRef,
    isFetchingNextPage,
    scrollContainerRef,
  } = useLogs({
    entityName,
    id,
    isAdminLogs,
    service,
  });
  return (
    <div className={styles.logs}>
      <Spin spinning={logListLoading} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      <Row justify="space-between" align="middle">
        <Col>
          <Row className={styles.title_container} align="middle">
            <Col className={styles.icon_wrapper}>
              <LogsIcon />
            </Col>
            <Col>
              <Typography.Text className={'font-size-16'} style={{ color: '#05796B', fontWeight: 600 }}>
                Logs
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button color="default" variant="filled" onClick={showDrawer} icon={<FilterIcon />} />
        </Col>
      </Row>
      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }} ref={scrollContainerRef}>
        {logs && Object.keys(logs).length ? (
          <Row>
            {Object.keys(logs).map((key, index) => (
              <LogGroup
                key={key}
                groupName={key}
                logs={logs[key]}
                lastLogRef={lastLogRef}
                firstLogRef={firstLogRef}
                isFirstGroup={index === 0}
                isLastGroup={index === Object.keys(logs).length - 1}
              />
            ))}
          </Row>
        ) : (
          <Empty style={{ marginTop: '10%' }} />
        )}
      </div>
      {isFetchingNextPage && (
        <Row justify={'center'} className={'margin-b-16'}>
          <Col span={24}>
            <Spin
              spinning={isFetchingNextPage}
              tip={'Loading Logs...'}
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            >
              <div />
            </Spin>
          </Col>
        </Row>
      )}
      <FilterDrawer
        title="Filter"
        placement="left"
        width={471}
        onClose={closeDrawer}
        open={filterDrawerVisible}
        onApply={() => form.submit()}
        onClear={clearFilters}
        onExpand={closeDrawer}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={applyFilters}
          initialValues={{ dateRange: [null, null], by: null }}
        >
          {entityName !== 'USER' && (
            <Form.Item name="updatedBy" label="Updated By" style={{ marginBottom: 10 }}>
              <Select allowClear options={adminsList} />
            </Form.Item>
          )}
          <Form.Item name="dateRange" label="Date Range">
            <RangePicker
              suffixIcon={<CalendarIcon />}
              className={styles.range_picker}
              popupClassName="fmg-range-picker"
            />
          </Form.Item>
        </Form>
      </FilterDrawer>
    </div>
  );
};
